import config from 'config/index';
import { callApi, getHotelId, getItem } from 'utils/globalFunction';
import { API_ROUTES, LOCALSTORAGE_KEYS } from 'utils/globalVariable';

export const connectAIModel = async (): Promise<any> => {
  const response = await callApi(
    config.REACT_APP_BASE_URL + API_ROUTES.connectAIModel,
    null,
    'post',
    true,
    false,
    getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
    '',
    false,
    '',
    false,
  );
  if (response !== null) {
    return { ...(response?.data || response || {}) };
  } else {
    return { response: null };
  }
};

export const sendPromptToAI = async (data, signal = null): Promise<any> => {
  const response = await callApi(
    config.REACT_APP_BASE_URL + API_ROUTES.generateAIContent,
    data,
    'post',
    true,
    false,
    getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
    '',
    false,
    '',
    false,
    {},
    signal,
  );
  if (response !== null) {
    return { ...(response?.data || {}) };
  } else {
    return { response: null };
  }
};

export const sendDocumentPromptToAI = async (
  data,
  signal = null,
): Promise<any> => {
  const response = await callApi(
    config.REACT_APP_BASE_URL + API_ROUTES.generateAIContentByDocument,
    data,
    'post',
    true,
    true,
    getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
    '',
    false,
    '',
    false,
    {},
    signal,
  );
  if (response !== null) {
    return { ...(response?.data || {}) };
  } else {
    return { response: null };
  }
};

export const aiUsageForWorkspace = async (data = {}): Promise<any> => {
  const response = await callApi(
    config.REACT_APP_BASE_URL + API_ROUTES.aiUsage,
    data,
    'get',
    true,
    true,
    getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
    '',
    false,
    '',
    false,
    {},
  );
  if (response !== null) {
    return { ...(response?.data || {}) };
  } else {
    return { response: null };
  }
};

export const generateInsights = async (data: {
  contextType?: string;
  contextData?: any;
  contextId?: string;
  includeChatHistory?: boolean;
}): Promise<any> => {
  const hotelId = getHotelId() as string;
  const response = await callApi(
    `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/ai-insights/generate`,
    data,
    'post',
    true,
    false,
    getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
    '',
    false,
    '',
    false,
  );
  if (response !== null) {
    return { ...(response?.data || {}) };
  } else {
    return { response: null };
  }
};
